import React from 'react';
import { Typography } from '@mui/material';
import { PageLayout } from "../components/page-layout";

export default function About() {
  return (<PageLayout>
  
    <div style={{ padding: '20px' }}>
      <Typography variant="h4">About Marble Stocks</Typography>
      
    </div>
<div>
<section className="max-w-3xl mx-auto p-6 bg-white rounded-2xl shadow-md">
<h2 className="text-2xl font-semibold mb-4">Legal Disclaimer</h2>


<p className="mb-3">
<strong>Marble Stocks</strong> provides educational content and data about U.S. and
Australian (ASX) publicly traded companies. The information on this site is intended for
informational and educational purposes only and does not constitute financial, investment,
tax, legal, or other professional advice.
</p>


<h3 className="font-medium mt-4 mb-2">No Financial Advice</h3>
<p className="mb-3">
The content on Marble Stocks is not a recommendation to buy, sell, or hold any security.
Nothing on this site is intended to be, and should not be construed as, investment advice,
an offer to sell, or a solicitation of an offer to buy any securities. You should not rely
on information on this site as the primary basis for making investment decisions.
</p>


<h3 className="font-medium mt-4 mb-2">Regulatory Status — United States</h3>
<p className="mb-3">
Marble Stocks is not registered with the U.S. Securities and Exchange Commission (SEC) and
is not a broker-dealer, investment adviser, or financial planner. The tools and
information provided are educational and are not subject to SEC oversight. For advice
regarding U.S. securities, consult a licensed financial professional or an adviser
registered with the SEC or your state securities regulator.
</p>


<h3 className="font-medium mt-4 mb-2">Regulatory Status — Australia (ASX)</h3>
<p className="mb-3">
Marble Stocks is not licensed by the Australian Securities and Investments Commission
(ASIC) and does not provide financial product advice, nor does it act as an Australian
financial services licensee. For guidance on ASX-listed securities or Australian tax
matters, consult an adviser licensed by ASIC or a qualified Australian financial
professional.
</p>


<h3 className="font-medium mt-4 mb-2">No Warranty &amp; Use at Your Own Risk</h3>
<p className="mb-3">
The data, analysis, charts, and other content are provided "as is" without warranty of any
kind. Marble Stocks does not guarantee the accuracy, completeness, or timeliness of the
information. Past performance is not indicative of future results. You are solely
responsible for your investment decisions and for any gains or losses that result.
</p>


<h3 className="font-medium mt-4 mb-2">External Links &amp; Third-Party Data</h3>
<p className="mb-3">
The site may contain links to third-party websites or display data from third-party
providers. Marble Stocks is not responsible for the content, products, or services of
those third parties and does not endorse them.
</p>


<h3 className="font-medium mt-4 mb-2">Consult a Professional</h3>
<p className="mb-6">
Before making any financial decisions, you should consult a licensed financial,
tax, or legal professional who can take into account your personal circumstances.
</p>


<div className="text-sm text-gray-600">
<p>Last updated: November 20, 2025</p>
<p>Contact: asxstockgraphs@gmail.com</p>
</div>
</section>
</div>
  </PageLayout>

  );
}